import { useState,useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap"
import { ArrowRightCircle } from "react-bootstrap-icons";
import headerImg from "../assets/img/header-img.jpeg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';


export const Banner = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(300 - Math.random() * 100);
    const [index, setIndex] = useState(1);
    const toRotate = [ "Web Developer", "Competitive Coder", "Open Source Contributor" ];
    const period = 900;


    useEffect(() => {
        let ticker = setInterval(() => {
          tick();
        }, delta);
    
        return () => { clearInterval(ticker) };
      }, [text])


      const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);
    
        setText(updatedText);

        if (isDeleting) {
            setDelta(prevDelta => prevDelta / 2);
          }
      
          if (!isDeleting && updatedText === fullText) {
            setIsDeleting(true);
            setIndex(prevIndex => prevIndex - 1);
            setDelta(period);
          } else if (isDeleting && updatedText === '') {
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setIndex(1);
            setDelta(500);
          } else {
            setIndex(prevIndex => prevIndex + 1);
          }
        }

    
    return(
        <section className="banner" id="home">
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} md={6} xl={7}>
                    <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                        <span className="tag-line">Welcome to my World!</span>
                        <h1>{'Hey! Sansrita here, '}<span className="txt-rotate" dataPeriod="1000" data-rotate='[ "Web Developer", "Competitive Coder", "Open Source Contributor" ]'><span className="wrap">{text}</span></span></h1>
                        <p>Currently 3rd year BTech Computer Science Engineering student.Dedicated coder and currently a Frontend developer and now working on MERN stack and AI. I have a massive interest in ML, App Development.</p>
             {/*           <button onClick={() => console.log('connect')} >Let's Connect <ArrowRightCircle size={24} /></button>   */}
                        </div>}
                      </TrackVisibility>

                    </Col>
                    <Col xs={6} md={8} xl={4}>
                    <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
                    </Col>
                </Row>
            </Container>
        </section>
        
    )
}